import { useTranslation } from "react-i18next";
import React, {
    useCallback,
    useContext,
    useEffect,
    useRef,
    useState,
} from "react";


import anime from "animejs";
import { MatchScoreWidget } from "../../../frontend/templates/_partials/MatchScoreWidget/MatchScoreWidgetForBild";

const getTemplateName = (template_name, t, cntLastGames) => {
    switch (template_name) {
        case "bild_attacking_zones":
            return t("AttackingZonesHeadline", { keyPrefix: "templates" });
        case "bild_mvp":
            return t("MVPHeadline", { keyPrefix: "templates" });
        case "bild_playercompare":
            return t("Head 2 Head", { keyPrefix: "templates" });
        case "bild_playercompare_season":
            return t("Head 2 Head", { keyPrefix: "templates" });
        case "bild_teamcompare_season":
            return t("Team Compare Headline", { keyPrefix: "templates" });
        case "bild_static_facts":
            return t("Top Facts", { keyPrefix: "templates" });
        case "bild_lineuptactics":
            return t("Lineup", { keyPrefix: "templates" });
        case "bild_heatmap":
            return t("Heatmap", { keyPrefix: "templates" });
        case "bild_hotzone":
            return t("Hot zone", { keyPrefix: "templates" });
        case "bild_standings":
            return t("Standings", { keyPrefix: "templates" });
        case "bild_goal":
            return t("wc_goal.headline", { keyPrefix: "templates" });
        case "bild_lastgames": {
            let label = ';'
            // lastGamesLen
            if (cntLastGames === 1) label = "Last Game";
            else if (cntLastGames === 2) label = "Last 2 Games";
            else if (cntLastGames === 3) label = "Last 3 Games";
            else label = "Last 4 Games"; // covers cntLastGames >= 4
            return t(label, { keyPrefix: "templates" });
        }
        case "bild_matchup":
            // return t("Last 10 games")
            return "Tabellenverlauf";
        case "bild_goalshots":
            return t("Shots on goal", { keyPrefix: "templates" });
        case "bild_topperformers":
            return t('Goals', { keyPrefix: "templates.TopPerformers" });
        default:
            return t("AttackingZonesHeadline", { keyPrefix: "templates" });
    }
}

const BildHeaderComponent = (props) => {
    const {
        data,
        otherData,
    } = props;

    const { t } = useTranslation();
    const templateName = data?.template_name ?? "";
    const id = `${templateName}_${data?.uuid}`;

    const { matchInfo, lastGames } =
        data?.data?.dynamic || {};
    const homeTeam = matchInfo?.home;
    const awayTeam = matchInfo?.away;
    const template_name = data?.template_name;
    const next_template_name = otherData?.template_name;
    const lastgames = lastGames || [];
    return <div className="main-header-content">
        <div className="main-header">
            <span className="current-header">{getTemplateName(template_name, t, lastgames?.length)}</span>
            <span className="next-header">{getTemplateName(next_template_name, t, lastgames?.length)}</span>
        </div>
        <MatchScoreWidget
            homeTeam={homeTeam}
            awayTeam={awayTeam}
            matchInfo={matchInfo}
        />
    </div>
};

export default BildHeaderComponent;
